import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import { EDUCATIONAL_INFORMATION_DEFAULTS } from '../const';

import { updateLocalStorage } from './updateLocalStorage';

export const addEducationalExperienceFields = (
  doc: CoverLetterDocumentType
): void => {
  const educationExperience = [
    ...(doc.educationExperience ?? []),
    EDUCATIONAL_INFORMATION_DEFAULTS,
  ];

  updateLocalStorage(`educationExperience`, educationExperience);
};
